/**
 * Bulk delete prepared drafts — UX thresholds.
 * For Media Devoted | Created By Ciro Autiero
 */

/** Ask for confirmation when deleting more than this many drafts in one action. */
export const PREPARED_DRAFTS_BULK_DELETE_CONFIRM_ABOVE_COUNT = 300;

/**
 * Above this the backend records no snapshot, so the delete is NOT undoable —
 * must match PREPARED_DROP_UNDO_MAX_ROWS on the server. Promising an undo that
 * will not be there is worse than warning that it won't.
 */
export const PREPARED_DRAFTS_UNDOABLE_MAX_COUNT = 1000;

/** The warning shown before a large delete — honest about what comes after. */
export const bulkDeleteConfirmMessage = (count: number): string =>
  count > PREPARED_DRAFTS_UNDOABLE_MAX_COUNT
    ? `Delete all ${count} selected draft(s)? This is past the undo limit of ${PREPARED_DRAFTS_UNDOABLE_MAX_COUNT}, so it CANNOT be undone.`
    : `Delete all ${count} selected draft(s)? You can put them back with "Undo last change".`;
